var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "forms-page" }, [
    _c(
      "div",
      { staticClass: "forms-filter-wrap" },
      [
        _c(
          "portal-filter-bar",
          { attrs: { label: _vm.$t("global.filter") } },
          [
            _c("portal-search-field", {
              attrs: {
                label: _vm.$t("global.filter"),
                placeholder: _vm.$t("global.filter"),
                "clear-label": _vm.$t("global.clear")
              },
              model: {
                value: _vm.filter,
                callback: function($$v) {
                  _vm.filter = $$v
                },
                expression: "filter"
              }
            }),
            _c("portal-select-field", {
              attrs: { label: _vm.$t("global.date"), options: _vm.dateOptions },
              model: {
                value: _vm.dateFilter,
                callback: function($$v) {
                  _vm.dateFilter = $$v
                },
                expression: "dateFilter"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    !_vm.isReady
      ? _c(
          "div",
          { staticClass: "forms-loading" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", size: 38, width: 3, color: "primary" }
            })
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass:
              "form-list-shell portal-compact-list-shell show-scrollbar"
          },
          [
            _c("v-data-table", {
              staticClass: "portal-compact-table",
              attrs: {
                headers: _vm.headers,
                items: _vm.combinedList,
                "disable-pagination": true,
                "hide-default-footer": true,
                "items-per-page": -1,
                "mobile-breakpoint": 200,
                "fixed-header": ""
              },
              on: {
                "click:row": function($event) {
                  return _vm.routeClick($event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "item.formName",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "form-name-cell",
                          attrs: { title: item.formName }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "form-icon",
                              attrs: { "aria-hidden": "true" }
                            },
                            [
                              _c("portal-icon", {
                                attrs: { name: "file-text", size: 17 }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "portal-cell-truncate portal-cell-primary"
                            },
                            [_vm._v(_vm._s(item.formName))]
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "item.formData.firstName",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.contactLabel
                        ? _c(
                            "span",
                            {
                              staticClass: "portal-cell-truncate",
                              attrs: { title: item.contactLabel }
                            },
                            [_vm._v(_vm._s(item.contactLabel))]
                          )
                        : _c("span", { staticClass: "portal-cell-muted" }, [
                            _vm._v("—")
                          ])
                    ]
                  }
                },
                {
                  key: "item.type",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.type === "SUBMITTED"
                        ? _c(
                            "portal-status-pill",
                            {
                              attrs: {
                                background: "var(--v-success_10-base)",
                                color: "var(--v-success-base)"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("forms.submissions.complete")) +
                                  " "
                              )
                            ]
                          )
                        : _c(
                            "portal-status-pill",
                            {
                              attrs: {
                                background: "var(--v-alert_10-base)",
                                color: "var(--v-alert-base)"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("forms.submissions.incomplete")
                                  ) +
                                  " "
                              )
                            ]
                          )
                    ]
                  }
                },
                {
                  key: "item.submittedAt",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.submittedAt
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "portal-cell-truncate portal-cell-muted",
                              attrs: {
                                title: _vm.DateTime.fromISO(
                                  item.submittedAt
                                ).toLocaleString(_vm.DateTime.DATETIME_MED)
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.DateTime.fromISO(
                                      item.submittedAt
                                    ).toLocaleString(_vm.DateTime.DATE_MED)
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _c("span", { staticClass: "portal-cell-muted" }, [
                            _vm._v("—")
                          ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }